export default __webpack_public_path__ + "static/media/Animals-04.01b8ab2b.png";